import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { getCurrentUser } from '@/selectors/user.selectors'
import { useReselector } from '@/utils/sharedHooks'
import { Button } from '@/ui'
import { useAnalyticsTrack, useAnalyticsView } from '@/features/amplitude'
import { FEATURE_FLAG_KEYS } from '@/features/open-feature'
import { useBooleanFlagValue } from '@openfeature/react-sdk'
import { NewObSplashScreen } from './NewObSplashScreen'
import { regular } from '@fortawesome/fontawesome-svg-core/import.macro'

// TODO: Migrate to V2
import { Loader } from 'semantic-ui-react'
import { H1GetStartedUpdatesObScreen } from './H1GetStartedUpdatesObScreen'

export const SetupLandingCard = () => {
  const currentUser = useReselector(getCurrentUser)
  const navigate = useNavigate()
  const pageView = useAnalyticsView()
  const shouldEnableH1GetStartedUpdates = useBooleanFlagValue(
    FEATURE_FLAG_KEYS.enableH1GetStartedUpdates,
    false
  )

  const track = useAnalyticsTrack()

  useEffect(() => {
    pageView('onboarding items landing')
  }, [pageView])

  if (!currentUser) return <Loader active />

  const handleContinueClick = () => {
    if (shouldEnableH1GetStartedUpdates) {
      track('completed onboarding items landing page to dashboard')
      navigate('/dashboard')
    } else {
      track('completed onboarding items landing page to baa')
      navigate('/onboarding-v2?stage=connect&step=baa')
    }
  }

  const getButtonText = () => {
    if (shouldEnableH1GetStartedUpdates) {
      return 'Continue to Dashboard'
    }
    return 'Continue'
  }

  return (
    <div className="flex flex-col gap-10 w-full max-w-2xl mx-auto my-8 px-4">
      {shouldEnableH1GetStartedUpdates ? (
        <H1GetStartedUpdatesObScreen />
      ) : (
        <NewObSplashScreen />
      )}
      <div className="flex justify-end border-t-1 border-neutral-200 pt-8">
        <Button
          variant="primary"
          size="md"
          onClick={handleContinueClick}
          iconRight={regular('chevron-right')}
        >
          {getButtonText()}
        </Button>
      </div>
    </div>
  )
}
